import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Footer } from './Footer'
import { Header } from './Header'

const prepositionSpace = /(^|[\s([{"„])((?:[AaIiOoUuWwZz])|(?:[Dd]o|[Nn]a|[Oo]d|[Pp]o|[Zz]a|[Ww]e|[Zz]e|[Kk]u|[Pp]od|[Nn]ad|[Bb]ez|[Dd]la|[Pp]rzez|[Mm]iędzy|[Pp]rzed|[Ww]śród|[Oo]bok|[Pp]onad)) (?=\S)/g

export function Layout() {
  const location = useLocation()
  useEffect(() => {
    if (location.hash) {
      window.requestAnimationFrame(() => document.getElementById(location.hash.slice(1))?.scrollIntoView())
    } else {
      window.scrollTo({ top: 0 })
    }
  }, [location.hash, location.pathname])

  useEffect(() => {
    if (import.meta.env.MODE === 'test') return

    const walker = document.createTreeWalker(document.getElementById('root') ?? document.body, NodeFilter.SHOW_TEXT)
    const textNodes: Text[] = []
    let node: Node | null

    while ((node = walker.nextNode())) textNodes.push(node as Text)

    textNodes.forEach((textNode) => {
      const parent = textNode.parentElement
      if (parent?.closest('script, style, textarea, a, button, h1, h2, h3, h4, h5, h6, .section--no-nbsp')) return
      const value = textNode.nodeValue ?? ''
      const matches = [...value.matchAll(prepositionSpace)]
      if (!matches.length) return

      const fragment = document.createDocumentFragment()
      let position = 0
      matches.forEach((match) => {
        const index = match.index ?? 0
        const prefixLength = match[1].length
        fragment.append(value.slice(position, index + prefixLength))
        const nonBreakingPhrase = document.createElement('span')
        nonBreakingPhrase.className = 'nonbreaking-space'
        nonBreakingPhrase.textContent = `${match[2]} `
        fragment.append(nonBreakingPhrase)
        position = index + match[0].length
      })
      fragment.append(value.slice(position))
      textNode.replaceWith(fragment)
    })
  }, [location.pathname])

  return <><a className="skip-link" href="#main-content">Przejdź do treści</a><Header /><main id="main-content"><Outlet /></main><Footer /></>
}
